import { render } from "./App.vue?vue&type=template&id=7028343c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7028343c&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__